<template>
  <v-container
    style="background-color: #eeeeee; color: #6b6868"
    class="rounded-xl"
    v-if="lastResearch.length > 0"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="10" offset-md="1">
          <h4 class="text-center font-weight-light text-h6">
            <v-icon large left style="color: #6b6868; position: relative"
              >mdi-history</v-icon
            >
            Retrouver des offres à partir de mes recherches récentes
          </h4>
          <ul class="font-weight-light text-h6">
            <li
              v-for="(elt, researchIndex) in this.lastResearchFormatted"
              :key="researchIndex"
            >
              <a
                v-on:click="updateSearchForm(elt)"
                class="font-weight-light"
                style="color: #2283a5; font-size: medium"
                v-if="elt.what !== ''"
              >
                ↳ {{ elt.what.replaceAll("`JB-WORDS-SEPARATOR`", ", ") }} -
                {{ elt.location !== '' ? elt.location : 'Tous les emplacements' }}
              </a>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "ViewLastJobSearchHistory",
  props: {
    parentFormUpdateCallback: Function,
  },
  data: function () {
    return {
      lastResearchFormatted: [],
      lastResearch: [],
    };
  },
  methods: {
    updateSearchForm: function (researchHistory) {
      this.parentFormUpdateCallback(researchHistory);
    },
  },
  mounted() {
    const httpClient = new HttpClient();
    httpClient
      .getLastJobSearch(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.lastResearch = value.data;
        this.lastResearchFormatted = this.lastResearch.slice(0, 3);
        console.log(this.lastResearchFormatted);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push("/logout");
        } else {
          alert("Une erreur s'est produite");
        }
        console.log(error);
      });
  },
});
</script>

<style scoped></style>
